import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {FrontIziviaTranslateService} from '../services/i18n/iziviaTranslate.service';
import {formatNumber} from '@angular/common';

@Pipe({
    name: 'powerMaxInWToKw'
})
export class PowerMaxInWToKwPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private readonly locale: string,
        private readonly translateService: FrontIziviaTranslateService) {
    }

    /**
     *
     * @param maxPowerInW The number to be formatted
     * @param digitsInfo Decimal representation options, specified by a string in the following format:
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
     * <ul>
     *     <li>minIntegerDigits: The minimum number of integer digits before the decimal point. Default is 1.</li>
     *     <li>minFractionDigits: The minimum number of digits after the decimal point. Default is 0.</li>
     *     <li>maxFractionDigits: The maximum number of digits after the decimal point. Default is 3.</li>
     * </ul>
     * From Angular DecimalPipe. Optional. Default is undefined.
     */
    transform(maxPowerInW: number, digitsInfo?: string): string {
        if (maxPowerInW) {
            return formatNumber(maxPowerInW / 1000, this.locale, digitsInfo) + ' kW';
        }

        return this.translateService.translate('infra.maxPowerUnknown');
    }
}
